import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=7527bea4&scoped=true&lang=scss"

import exportComponent from "E:\\TeamCity\\buildAgent\\work\\44e3aa492d05d81f\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7527bea4"]])

export default __exports__